import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { ContactRoutingModule } from './contact-routing.module';
import { ContactContainerComponent } from './contact-container.component';
import { DocumentsComponent } from './components/documents/documents.component';
import { SharedModule } from 'src/app/middleware/shared/shared.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CoreParentComponent } from './components/coreParent/core-parent.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DocumentdetailComponent } from './components/documentdetail/documentdetail.component';
import { documentDetailDirective } from './doumentdetail.directive';
import { ContactListComponent } from './components/contact-list/contact-list.component';
import { MatChipsModule } from '@angular/material/chips';
import { TouchesComponent } from './components/touches/touches.component';
import { CreateTouchesComponent } from './components/touches/create-touches/create-touches.component';
import { ContactDetailComponent } from './components/contact-detail/contact-detail.component';
import { DocumentViewerComponent } from './components/document-viewer/document-viewer.component';
import { PhotosComponent } from './components/photos/photos.component';
import { ShareFileComponent } from './components/share-file/share-file.component';
import { TaskComponent } from './components/task/task.component';
import { CreateTaskComponent } from './components/task/create-task/create-task.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgxMatDrpModule } from 'ngx-mat-daterange-picker';
import { LinkPiComponent } from './components/task/link-pi/link-pi.component';
import { TaskDetailComponent } from './components/task/task-detail/task-detail.component';
import { ProcessIntelligenceComponent } from './components/process-intelligence/process-intelligence.component';
import { CreatePiComponent } from './components/process-intelligence/create-pi/create-pi.component';
import { ApiEndPointsDocument } from './common/apiUrls/api-end-points-document';
import { ApiEndPointsCore } from './common/apiUrls/api-end-points-core';
import { CoreService } from './services/coreService/core.service';
import { CommonService } from 'src/app/middleware/common/common.service';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { CustomvalidationService } from 'src/app/middleware/common/resuableServices/validatorServices';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { AddFolderReqVm } from 'src/app/viewModels/core/add-folder-req-vm';
import { FolderReqVm } from 'src/app/viewModels/core/folder-req-vm';
import {
  UploadDocumentReqVm,
  DocumentsByFolderReqVm,
} from 'src/app/viewModels/core/upload-document-req-vm';
import { DeleteDocumentReqVm } from 'src/app/viewModels/core/delete-document-req-vm';
import { SettingService } from '../settings/services/settingService/setting.service';
import { ApiEndPointsSettings } from '../settings/common/apiUrls/api-end-points-settings';
import { ContactListingComponent } from './components/contact-listing/contact-listing.component';
import { TemplateReqVM } from 'src/app/viewModels/core/template-req-vm';
import { AddListingComponent } from './components/contact-listing/add-listing/add-listing.component';
import { RequestDocumentComponent } from './components/request-document/request-document.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { AddContactComponent } from './components/contact-list/add-contact/add-contact.component';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { A11yModule } from '@angular/cdk/a11y';
import { MatTableModule } from '@angular/material/table';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ListingDetailComponent } from './components/contact-listing/listing-detail/listing-detail.component';
import { MatCardModule } from '@angular/material/card';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { LocaleService } from 'ngx-daterangepicker-material';
import { ApiEndPointsContact } from '../contact/common/apiUrls/api-end-points-contact';
import { ContactsService } from './services/coreService/contacts.service';
import { ContactVm, AddContactVm, UpdateColumnContactVm, ReorderColumnContactVm,
    FilteredContactVm, CreateContactFilterVm, FileContactModelVM, ContactsVm } from 'src/app/viewModels/core/contacts-vm';
import { FilterComponent } from './components/contact-listing/filter/filter.component';
import { CompanysVm, FilteredCompanyVm } from 'src/app/viewModels/core/company-vm';
import { HTTP_INTERCEPTORS ,HttpClientModule } from '@angular/common/http';
import { Interceptor } from 'src/app/middleware/authentication/interceptor/auth-interceptor';
import { DocumentService } from './services/coreService/document.service';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { MatTreeModule } from '@angular/material/tree';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HTMLDataComponent } from './components/html-data/html-data.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { KanbanContactViewComponent } from './components/kanban-view/kanban-view.component';
import { FormReportsComponent } from './components/formReports/formReports.component';
const maskConfig: Partial<IConfig> = {
  validation: false,
};
@NgModule({
  declarations: [
    ContactContainerComponent,
    DocumentsComponent,
    CoreParentComponent,
    DocumentdetailComponent,
    documentDetailDirective,
    ContactListComponent,
    TouchesComponent,
    CreateTouchesComponent,
    ContactDetailComponent,
    DocumentViewerComponent,
    HTMLDataComponent,
    PhotosComponent,
    ShareFileComponent,
    TaskComponent,
    CreateTaskComponent,
    LinkPiComponent,
    TaskDetailComponent,
    ProcessIntelligenceComponent,
    CreatePiComponent,
    ContactListingComponent,
    AddListingComponent,
    RequestDocumentComponent,
    AddContactComponent,
    ListingDetailComponent,
    FilterComponent,
    KanbanContactViewComponent,
    FormReportsComponent
  ],
  imports: [
    CommonModule,
    ContactRoutingModule,
    SharedModule,
    MatTabsModule,
    FlexLayoutModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatRadioModule,
    MatDatepickerModule,
    NgxMatDrpModule,
    NgxDaterangepickerMd,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatTableModule,
    DragDropModule,
    ScrollingModule,
    MatChipsModule,
    MatCardModule,
    NgxMaterialTimepickerModule,
    NgxDocViewerModule,
    MatTreeModule,
    MatProgressSpinnerModule,
    NgxMaskModule.forRoot(maskConfig),
    ClipboardModule
  ],

  providers: [
    ApiEndPointsDocument,
    DocumentService,
    ApiEndPointsCore,
    ApiEndPointsContact,  
    CoreService,
    CommonService,    
    Constants,
    StatusConstant,
    ReusableClasses,
    CustomvalidationService,
    EncryptionService,
    AddFolderReqVm,
    FolderReqVm,
    UploadDocumentReqVm,
    DeleteDocumentReqVm,
    DocumentsByFolderReqVm,
    SettingService,
    ApiEndPointsSettings,
    ContactsService,
    ContactVm,
    ContactsVm,
    CompanysVm,
    FilteredCompanyVm,
    //CoreVm,
    //AddCoreVm,
    AddContactVm,
    //UpdateColumnCoreVm,
    UpdateColumnContactVm,
    //ReorderColumnCoreVm,
    ReorderColumnContactVm,
    //FilteredCoreVm,
    FilteredContactVm,
    CreateContactFilterVm,
    FileContactModelVM,
    TemplateReqVM,
    A11yModule,
    CdkTableModule,
    CdkTreeModule,
    DragDropModule,
    MatTableModule,
    HttpClientModule,
    {provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true},
  ],
})
export class ContactModule {}
